export class SessionStorage {
    constructor() {
        this.sessionStorageAvailable = this.checkStorageAvailable();
    }

    set(key, value) {
        if (value) {
            if (this.sessionStorageAvailable) {
                try {
                    if (typeof value !== 'string') {
                        value = JSON.stringify(value);
                    }
                    sessionStorage.setItem(key, value);
                } catch (e) {

                }
            }
        }
    }

    get(key, isObject = true) {
        let value = null;
        if (this.sessionStorageAvailable) {
            try {
                const storageValue = sessionStorage.getItem(key);
                value = isObject ? JSON.parse(storageValue) : storageValue;
            } catch (e) {
                value = isObject ? {} : '';
            }
        }
        if (value) {
            return value;
        }
        return null;
    }

    flush(key, isObject = true) {
        const value = this.get(key, isObject);
        if (value) {
            this.remove(key);
            return value;
        }
        return null;
    }

    remove(key) {
        if (this.sessionStorageAvailable) {
            try {
                if (this.sessionStorageAvailable) {
                    sessionStorage.removeItem(key);
                }
            } catch (e) {

            }
        }
    }

    checkStorageAvailable() {
        return typeof SessionStorage !== 'undefined';
    }
}
